import { useState } from "react";

const useCopyToClipboard = () => {
    const [copiedText, setCopiedText] = useState("");
    /**
     * @param {string} text // Text to copy
     * @returns {boolean} success
     */
    const copy = async (text) => {
        // Check if copying is supported
        if (!navigator?.clipboard) {
            return false;
        }

        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            setCopiedText(null);
            return false;
        }
    };

    return {
        copiedText,
        copy,
    };
};

export default useCopyToClipboard;
